import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-view-pdf-in-popup',
  templateUrl: './view-pdf-in-popup.component.html',
  styleUrl: './view-pdf-in-popup.component.scss'
})
export class ViewPdfInPopupComponent {

  base64: string;
  title: string;
  fileType: 'IMAGE' | 'PDF' | 'VIDEO' | 'AUDIO';

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<ViewPdfInPopupComponent>
  ) {
    this.base64 = data?.base64;
    this.title = data?.title;
    this.fileType = data?.fileType;
  }

  closeThisModal(close: boolean) {
    if (close) {
      this.dialogRef.close();
    }
  }

}
